import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';

gsap.registerPlugin(ScrollToPlugin, useGSAP);

type GsapContextSafeType = {
  scrollId?: string;
  scrollEle?: Element;
  offsetY?: number;
  onComplete?: () => void;
  clearSearchParams?: boolean;
  isCenter?: boolean;
  onStart?: () => void;
  duration?: number;
};

const getEleCenterOffset = (scrollId?: string, scrollEle?: Element) => {
  const ele = scrollId ? document.getElementById(scrollId) : scrollEle;
  const eleRect = ele?.getBoundingClientRect();
  return window.innerHeight / 2 - (eleRect?.height || 0) / 2;
};

const performScroll = ({
  scrollId = '',
  scrollEle,
  offsetY = BASE_HEADER_HEIGHT,
  onComplete,
  clearSearchParams = false,
  isCenter = false,
  onStart,
  duration = 0.3,
}: GsapContextSafeType) => {
  gsap.to(window, {
    duration: duration,
    scrollTo: {
      y: scrollEle || `#${scrollId}`,
      offsetY: isCenter ? getEleCenterOffset(scrollId, scrollEle) : offsetY,
    },
    onStart: () => {
      if (clearSearchParams) {
        const url = new URL(window.location.href);
        url.search = '';
        window.history.replaceState({}, '', url.toString());
      }
      onStart?.();
    },
    onComplete,
  });
};
export const useGsapContextSafe = () => {
  const { contextSafe } = useGSAP();

  return contextSafe((params: GsapContextSafeType) => {
    performScroll(params);
  });
};

export const useGsap = ({
  deps = [],
  condition = true,
  ...params
}: GsapContextSafeType & { condition?: boolean; deps?: any[] }) => {
  useGSAP(() => {
    if (!condition) return;
    performScroll(params);
  }, deps);
};
